import ModifyContainer from "../../../../components/@repositories/containers/ModifyContainer";

import { routeTypes } from "../../../../../../hooks/useSystemRoutes"

export default function ContainerModifyPage() {

    return (
        <ModifyContainer 
            routeType={routeTypes.admin}
        />
    )
}